<template>
  <CreateTimelineModal
    v-if="showCreateTimelineModal"
    :projectId="projectId"
    @closeModal="closeModal"
  />
  <EditTimelineModal
    v-if="showEditTimelineModal"
    :projectId="projectId"
    :timelineId="timelineIdSelected"
    @closeModal="closeModal"
  />
  <DetailsResponsibleModal
    v-if="showDetailsResponsibleModal"
    :projectId="projectId"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Cronograma de Execução</h6>
      <div v-if="timeline.steps && canEditProject" class="ms-2">
        <span
          class="badge bg-light border-start border-width-3 text-body rounded-start-0 border-primary"
        >
          <strong>Instrução:</strong> Clique no mês desejado para marcar ou
          desmarcar a execução da etapa
        </span>
      </div>
      <div v-if="timeline.steps" class="ms-auto">
        <button
          class="btn btn-sm btn-outline-primary"
          title="Visualizar responsabilidades"
          @click="showDetailsResponsibleModal = true"
        >
          Visualizar responsabilidades
        </button>
      </div>
    </div>
    <div v-if="timeline.steps" class="table-responsive">
      <table class="table table-xs table-bordered">
        <thead class="table-primary">
          <tr>
            <th class="position-sticky start-0 w-25 step">Atividade</th>
            <th
              v-for="index in projectSelected.runtime"
              :key="index"
              class="text-center"
            >
              {{ index }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="step in timeline.steps" :key="step.id">
            <td
              class="position-sticky start-0 table-success"
              :class="{ 'table-danger': step.percentTimeline != 100 }"
              :title="step.description"
            >
              {{ step.order }} - {{ step.title }}
            </td>
            <td
              v-for="timeline in step.timelines"
              :key="timeline.id"
              class="text-center p-2 cursor-pointer"
              :class="{ active: Number(timeline.active) === 1 }"
              @click="editTimeline(timeline.id)"
              :title="
                canEditProject ? 'Clique para marcar/desmarcar o mês' : ''
              "
            >
              <span v-if="Number(timeline.active) === 1">
                <small>{{ timeline.percent }}%</small>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-body text-center">
      <p class="mb-0">
        Este sumário executivo não possui nenhum cronograma de execução
        cadastrado
      </p>
      <button
        v-if="canEditProject"
        type="button"
        class="btn btn-sm btn-primary mt-3"
        title="Criar Cronograma"
        @click="showCreateTimelineModal = true"
      >
        Criar Cronograma
      </button>
    </div>
  </div>
</template>

<script>
import CreateTimelineModal from '@/components/projects/timeline/CreateTimelineModal.vue'
import EditTimelineModal from '@/components/projects/timeline/EditTimelineModal.vue'
import DetailsResponsibleModal from '@/components/projects/timeline/DetailsResponsibleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'TimelineProject',

  components: {
    CreateTimelineModal,
    EditTimelineModal,
    DetailsResponsibleModal,
    LoadingData,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateTimelineModal: false,
      showEditTimelineModal: false,
      showDetailsResponsibleModal: false,
      timeline: {},
      timelineIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['projectSelected', 'canEditProject']),
  },

  methods: {
    async getTimeline() {
      try {
        this.timeline = await this.$store.dispatch(
          'getProjectTimelines',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    editTimeline(timelineId) {
      if (this.canEditProject) {
        this.timelineIdSelected = timelineId
        this.showEditTimelineModal = true
      }
    },

    closeModal(loadTimeline) {
      if (loadTimeline) {
        this.getTimeline()
      }
      this.showCreateTimelineModal = false
      this.showEditTimelineModal = false
      this.showDetailsResponsibleModal = false
    },
  },

  mounted() {
    this.getTimeline()
  },
}
</script>

<style scoped>
td.active {
  background-color: #57646a !important;
  color: #fff !important;
}

th.step {
  min-width: 250px;
  max-width: 300px;
}
</style>
